import { useTranslation } from "react-i18next";

import { cn } from "@/lib/utils";

interface StatusBadgeProps {
  on: boolean;
  /** The text; "Aan" or "Uit" (in the dashboard's language) by default. */
  label?: string;
  className?: string;
}

/** A small on/off badge: the blue tint when on, a grey outline when off. */
export function StatusBadge({ on, label, className }: StatusBadgeProps) {
  const { t } = useTranslation();
  return (
    <span
      className={cn(
        "inline-flex shrink-0 items-center gap-1.5 rounded-sm border px-2 py-0.5 text-xs font-semibold whitespace-nowrap",
        on ? "bg-accent-light text-primary border-transparent" : "border-border text-muted",
        className,
      )}
    >
      <span
        aria-hidden="true"
        className={cn("h-1.5 w-1.5 rounded-full", on ? "bg-success" : "bg-muted")}
      />
      {label ?? (on ? t("common.on") : t("common.off"))}
    </span>
  );
}
